import Failure from '../../../core/Failure';
import { ICompany } from '@leedpulse-monorepo/interfaces';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function getCompanyById(companyId: string, auth: Authentication | null): Promise<ICompany | null> {
  try {
    const res = await HttpClient.get(`/company/${companyId}`, auth?.token);
    if(res.success) {
      return res.data as ICompany;
    } else {
      return null;
    }
  } catch (e) {
    console.log('error: ', e);
    throw new GetCompanyByIdFailure();
  }
}

export class GetCompanyByIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanyById;
